/// <amd-module name="VSS/Ext/RemoteServiceProvider" />
import React = require("react");

import { ExternalContent, IExternalContentLoadedEvent } from "VSS/Ext/ExternalContent";
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { IContributedService, IRemoteServiceProvider, IVssContributionService } from "VSS/Platform/Contribution";
import { IVssLayoutManager } from "VSS/Platform/Layout";

class ExternalContentServiceProvider extends VssService implements IRemoteServiceProvider {
    private backgroundHosts: { [key: string]: Promise<IExternalContentLoadedEvent> } = {};

    public getService<T extends IVssService>(contributionId: string, contributedService: IContributedService): Promise<T | undefined> {
        return this.getBackgroundHost(contributionId, contributedService).then(e => {
            return e.proxy!.getRemoteObjectProxy<T>(contributedService.serviceName || contributionId, contributedService.configuration).then(svc => {
                if (e.sdkVersion > 0) {
                    (svc as any)._sdkVersion = e.sdkVersion;
                }
                return svc;
            });
        });
    }

    private getBackgroundHost(contributionId: string, contributedService: IContributedService): Promise<IExternalContentLoadedEvent> {
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        const contributionProvider = contributionService.getContributionProvider(contributionId);

        if (!contributionProvider || !contributedService.uri) {
            return Promise.reject(new Error(`No contribution provider or uri for ${contributionId}.`));
        }

        const backgroundHostKey = `${contributionProvider.id}-${contributedService.uri}`;
        let promise = this.backgroundHosts[backgroundHostKey];
        if (promise) {
            return promise;
        }

        promise = new Promise((resolve, reject) => {
            const layoutService = this.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
            layoutService.renderCallout((onDismiss: () => void) => {
                return React.createElement(ExternalContent, {
                    contributionId: contributionId,
                    contributionUri: contributedService.uri,
                    initialHandshakeData: contributedService.configuration,
                    className: "hidden",
                    backgroundHost: true,
                    onLoaded: loadedEvent => {
                        if (loadedEvent.proxy) {
                            resolve(loadedEvent);
                        } else {
                            reject(new Error(`No interaction proxy returned for ${contributionId}.`));
                        }
                    }
                });
            });
        });

        this.backgroundHosts[backgroundHostKey] = promise;
        return promise;
    }
}

Services.add("ExternalContentServiceProvider", { serviceFactory: ExternalContentServiceProvider });
